import React, { useState } from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function ConsentWall({ onAccept, onDecline }) {
  const [agreed, setAgreed] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="w-full h-full min-h-screen bg-background flex items-center justify-center p-6 font-sans">
      <div className="max-w-md w-full bg-[#1a1a1a] border border-gray-800 rounded-xl p-8 flex flex-col items-center text-center shadow-2xl">
        <div className="w-16 h-16 bg-blue-900/30 rounded-2xl flex items-center justify-center mb-6 border border-blue-500/30">
          <ShieldCheck className="w-9 h-9 text-blue-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-2">{t("Welcome to SnipIT", "Welcome to SnipIT")}</h1>
        
        <p className="text-gray-400 mb-8 text-sm">
          {t("consent_wall_subtitle", "Before you get started, please review and accept our Privacy Policy and Terms of Service to continue.")}
        </p>

        <div className="w-full bg-background border border-gray-800 rounded-lg p-4 mb-6 text-left">
          <label className="flex items-start gap-3 cursor-pointer group">
            <div className="relative flex items-center pt-1">
              <input 
                type="checkbox" 
                className="w-5 h-5 cursor-pointer accent-blue-500 bg-[#1a1a1a] border-gray-700 rounded"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
              />
            </div>
            <div className="text-sm text-gray-300">
              {t("consent_terms_text", "I have read and agree to the")}{' '}
              <a href="https://www.snipit.devitsystems.com/privacy" target="_blank" rel="noreferrer" className="text-blue-400 hover:text-blue-300 underline underline-offset-2" onClick={(e) => e.stopPropagation()}>
                {t("privacy_policy", "Privacy Policy")}
              </a>
              {' '}and{' '}
              <a href="https://www.snipit.devitsystems.com/terms" target="_blank" rel="noreferrer" className="text-blue-400 hover:text-blue-300 underline underline-offset-2" onClick={(e) => e.stopPropagation()}>
                {t("terms_of_service", "Terms of Service")}
              </a>.
            </div>
          </label>
        </div>

        <button 
          onClick={onAccept}
          disabled={!agreed}
          className="w-full bg-blue-600 hover:bg-blue-500 disabled:bg-gray-800 disabled:text-gray-500 disabled:cursor-not-allowed text-white font-bold py-3 px-4 rounded transition-colors flex items-center justify-center gap-2"
        >
          {t("continue", "Continue")} <ArrowRight className="w-4 h-4" />
        </button>
        {onDecline && (
          <button 
            onClick={onDecline}
            className="w-full mt-3 bg-transparent border border-gray-700 hover:bg-gray-800 text-gray-400 font-bold py-3 px-4 rounded transition-colors flex items-center justify-center gap-2"
          >
            {t("decline", "Decline & Return")}
          </button>
        )}
      </div>
    </div>
  );
}
